import { CartItem, ShippingItem } from '@pedix-workspace/utils';

export function transformCartItemsToShippingItems(cartItems: CartItem[]): ShippingItem[] {
  const shippingItems: ShippingItem[] = [];
  let excludedItemsCount = 0;

  for (const cartItem of cartItems) {
    const items = cartItem.selectedPresentation?.items || [cartItem.product];
    for (const item of items) {
      const weight = item.weight;
      const height = item.height;
      const length = item.length;
      const width = item.width;

      if (!weight || !height || !length || !width) {
        excludedItemsCount++;
        console.warn(`Item "${cartItem.product.name}" no tiene dimensiones válidas - se excluye del cálculo de envío`, {
          weight,
          height,
          length,
          width
        });
        continue;
      }

              // Para presentaciones: cartItem.qty * item.quantity (cantidad de cada item en la presentación)
        // Para productos normales: cartItem.qty * 1 (ya que item.quantity será undefined)
        const itemQuantity = (item as any).quantity || 1;
        const totalQuantity = cartItem.qty * itemQuantity;

      shippingItems.push({
        description: cartItem.product.name,
        quantity: totalQuantity,
        value: cartItem.product.price,
        weight: weight,
        height: height,
        length: length,
        width: width,
      });
    }
  }

  console.info(`Transformación completada: ${shippingItems.length} items válidos, ${excludedItemsCount} items excluidos`);

  if (shippingItems.length === 0) {
    console.error('Ningún item tiene dimensiones válidas para calcular envío');
  }

  return shippingItems;
}

// Nueva función para validar si hay productos sin medidas
export function hasItemsWithoutDimensions(cartItems: CartItem[]): boolean {
  for (const cartItem of cartItems) {
    const items = cartItem.selectedPresentation?.items || [cartItem.product];
    for (const item of items) {
      const weight = item.weight;
      const height = item.height;
      const length = item.length;
      const width = item.width;

      if (!weight || !height || !length || !width) {
        return true; // Encontramos al menos un item sin dimensiones
      }
    }
  }
  return false; // Todos los items tienen dimensiones
}
